import React from 'react';
export function Footer() {
  return <footer className="bg-[#050505] border-t border-divider text-center py-7 px-5 text-xs text-[#555]" data-id="element-73">
      <strong className="text-gold" data-id="element-74">✝️ MISIÓN INFLUENCIA™</strong>
      <br data-id="element-75" />© 2026 Misión Influencia. Todos los derechos reservados.
    </footer>;
}